import { useInfiniteQuery, useQuery } from '@tanstack/react-query';

import { getMissionDetail, getMissions } from '../functions/missions';
import { MissionParams } from '../models/missionModel';

export const useGetMissions = (params: MissionParams) =>
  useInfiniteQuery({
    queryKey: ['get-missions', params.n, params.limit, params.missionTypes],
    queryFn: getMissions,
    initialPageParam: params.n?.toString(),
    getNextPageParam: (lastPage) => {
      if (lastPage.last) {
        return lastPage.last;
      } else {
        return null;
      }
    }
  });

export const useGetMissionDetail = (missionId: string) =>
  useQuery({
    queryKey: ['get-mission-detail'],
    queryFn: () => getMissionDetail({ missionId }),
    enabled: !!missionId
  });
